/** Çoklu sekme: WS lideri gelen bildirimleri diğer sekmelere iletir */

const CHANNEL = 'point-sync-v1';
const LEADER_KEY = 'point_ws_leader';
const LEADER_TS_KEY = 'point_ws_leader_ts';
const LEADER_TTL_MS = 8000;

let bc = null;
let heartbeatTimer = null;

function tabId() {
  let id = sessionStorage.getItem('point_tab_id');
  if (!id) {
    id = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem('point_tab_id', id);
  }
  return id;
}

export function isWsLeaderTab() {
  if (typeof localStorage === 'undefined') return true;
  const now = Date.now();
  const leader = localStorage.getItem(LEADER_KEY);
  const ts = Number(localStorage.getItem(LEADER_TS_KEY) || 0);
  const mine = tabId();
  if (!leader || leader === mine || now - ts > LEADER_TTL_MS) {
    localStorage.setItem(LEADER_KEY, mine);
    localStorage.setItem(LEADER_TS_KEY, String(now));
    return true;
  }
  return leader === mine;
}

function refreshLeaderHeartbeat() {
  if (!isWsLeaderTab()) return;
  localStorage.setItem(LEADER_TS_KEY, String(Date.now()));
}

export function initSyncBroadcast() {
  if (typeof BroadcastChannel === 'undefined') return () => {};
  bc = new BroadcastChannel(CHANNEL);

  heartbeatTimer = setInterval(refreshLeaderHeartbeat, LEADER_TTL_MS / 2);
  refreshLeaderHeartbeat();

  return () => {
    if (heartbeatTimer) clearInterval(heartbeatTimer);
    heartbeatTimer = null;
    try { bc?.close(); } catch { /* ignore */ }
    bc = null;
    if (localStorage.getItem(LEADER_KEY) === tabId()) {
      localStorage.removeItem(LEADER_KEY);
      localStorage.removeItem(LEADER_TS_KEY);
    }
  };
}

export function broadcastNotification(notification) {
  if (!bc || !notification) return;
  try {
    bc.postMessage({ type: 'notification', payload: notification });
  } catch { /* ignore */ }
}

export function subscribeSyncBroadcast(handler) {
  if (!bc || typeof handler !== 'function') return () => {};
  const onMessage = (ev) => {
    const msg = ev?.data;
    if (msg?.type === 'notification' && msg.payload) {
      handler(msg.payload);
    }
    if (msg?.type === 'bundle-updated' && msg.detail) {
      window.dispatchEvent(new CustomEvent('cari-sync-updated', { detail: msg.detail }));
    }
  };
  bc.addEventListener('message', onMessage);
  return () => bc?.removeEventListener('message', onMessage);
}

export function broadcastBundleUpdated(detail) {
  if (!bc || !detail) return;
  try {
    bc.postMessage({ type: 'bundle-updated', detail });
  } catch { /* ignore */ }
}
